module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7a7c16facb15bf57beb7e5830a10fe5c.png";